/* ============================================================
 * NauticIQ contact form — mailto submission, ported from the
 * Next.js contact page (no mail backend module installed yet).
 * ============================================================ */

(function () {
  'use strict';

  function init() {
    var form = document.getElementById('nqContactForm');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var data = new FormData(form);
      var name = String(data.get('name') || '');
      var email = String(data.get('email') || '');
      var company = String(data.get('company') || '');
      var boats = String(data.get('boats') || '');
      var product = String(data.get('product') || 'General');
      var message = String(data.get('message') || '');

      var subject = encodeURIComponent('Demo request — ' + product);
      var body = encodeURIComponent(
        'Name: ' + name + '\nEmail: ' + email + '\nCompany: ' + company +
        '\nBoats: ' + boats + '\nProduct: ' + product + '\n\n' + message
      );

      window.location.href = 'mailto:hello@nauticiq.com?subject=' + subject + '&body=' + body;

      var sent = form.querySelector('[data-nq-contact-sent]');
      if (sent) sent.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
